/**
 * Registro único de la trayectoria de Gob 24/7: reconocimientos, entidades y voces.
 * Lo consumen TrayectoriaView y HomeCasos; cambiar un premio o un caso se hace aquí.
 */
import fotoBuenDiseno from '@/assets/premios/buen-diseno.webp'
import fotoIndigo from '@/assets/premios/indigo.webp'
import logoCali from '@/assets/logo-vector-alcaldia-de-santiago-de-cali.webp'
import logoMiranda from '@/assets/logo-miranda.webp'
import logoIndigo from '@/assets/premio-indigo.webp'
import logoBuenDiseno from '@/assets/pill_logo_premio_buen_diseno.svg'

/*
 * Fotografía de la entrega (tipo 2) más la ficha del jurado. Cada campo vacío se omite al
 * renderizar: un premio se publica con lo verificado, nunca completado.
 */
export const RECONOCIMIENTOS = [
  {
    id: 'premios-indigo',
    nombre: 'Premio indigo innovación pública digital 2018',
    distincion: 'Primer lugar en procesos digitales y segundo lugar en iniciativas digitales ODS',
    categoria: 'Diseño para la inclusión, equidad y desarrollo social',
    otorgante: '',
    anio: '',
    logo: logoIndigo,
    foto: fotoIndigo,
    alt: 'El equipo de Gob 24/7 con el galardón de los Premios Índigo.',
    significado: 'Valida nuestra capacidad e innovación pública. Otorgado por MINTIC y PNUD'
  },
  {
    id: 'buen-diseno-colombia',
    nombre: 'Premio Buen Diseño Colombia 2025',
    distincion: 'Segundo lugar en diseño para la inclusión, equidad y desarrollo social.',
    categoria: 'Diseño para la inclusión, equidad y desarrollo social',
    otorgante: '',
    anio: '',
    logo: logoBuenDiseno,
    foto: fotoBuenDiseno,
    alt: 'Entrega del reconocimiento del Premio Buen Diseño Colombia al equipo de Gob 24/7.',
    significado: 'Valida nuestro criterio de diseño con impacto real. Otorgado por MINCIT y aliados institucionales en colaboración con el gobierno de Japón.'
  },
  
]

/*
 * `texto` es el resumen aprobado del Inicio (no se edita). `reto` e `intervencion` son propios de
 * /trayectoria. El alcance medido no se publica hasta que producto lo verifique.
 */
export const CASOS = [
  {
    id: 'santiago-de-cali',
    entidad: 'Alcaldía de Santiago de Cali, Valle del Cauca',
    solucion: 'Visión 360° del Ciudadano',
    ruta: '/vision-360',
    registro: 'humano',
    claseMarca: 'bg-signal-human',
    logo: logoCali,
    claseLogo: 'h-28',
    texto: 'Caracterización ciudadana y atención a habitantes de calle en un expediente único, con índice de vulnerabilidad y mapas de calor para priorizar la atención.',
    reto: 'La atención social se repartía entre programas que no compartían información. Cada uno levantaba su propio formulario y guardaba su propia versión de la misma persona, así que priorizar a quien más lo necesitaba dependía de la memoria de cada equipo.',
    intervencion: 'Se implementó la visión 360° del ciudadano: expediente único digital, caracterización con índice de vulnerabilidad y el módulo de habitante de calle, con mapas de calor que muestran dónde se concentra la población vulnerable de la ciudad.'
  },
  {
    id: 'miranda',
    entidad: 'Alcaldía de Miranda, Cauca',
    solucion: 'Plan de Desarrollo - Plan de Acción - Gestión de Tareas ',
    ruta: '/planes-desarrollo',
    registro: 'dato',
    claseMarca: 'bg-signal-data',
    logo: logoMiranda,
    claseLogo: 'h-24',
    texto: 'Seguimiento del plan de desarrollo y de los planes de acción de sus dependencias en un solo lugar, con evidencias y alertas de tareas vencidas.',
    reto: 'El plan de desarrollo y los planes de acción de las dependencias vivían en archivos separados. El avance solo se conocía en los cortes de reporte, cuando ya no quedaba margen para corregir.',
    intervencion: 'Se implementaron los planes de desarrollo y los planes de acción combinando la gestión de tareas y proyectos en un mismo lugar: cada meta con su responsable, sus evidencias cargadas y alertas cuando una tarea vence.'
  }
]

/*
 * Citas textuales del video institucional que el Inicio ya publica (public/captions/hero-es.vtt).
 * `nombre` y `cargo` quedan vacíos hasta que comercial confirme atribución y consentimiento.
 */
export const VOCES = [
  {
    id: 'tramites-en-minutos',
    cita: 'Antes dependíamos de trámites difíciles, ahora con Gob 24/7 gestionamos todo en minutos.',
    nombre: '',
    cargo: '',
    entidad: 'Diana Pereira - Coordinadora Programa Habitante en Calle - Secretaria de Bienestar Social.'
  }
]
